import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const m = {
  display: "block"
}, f = ({ size: t = 16, useVw: n, useRem: c, color: o, withColor: l, removeClassName: e, disableSSR: d, style: r, ...h }) => {
  const p = r ? { ...m, ...r } : m;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: d }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-kuaixun", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), height: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: p, fill: "none", ...h }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "32px-å¿«è®¯"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: l ? i(o, 0, "#262933") : "#262933",
        datafollowfill: l ? i(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M8.602 6.78a2.482 2.482 0 0 1 2.482-2.482h14.061A2.664 2.664 0 0 1 27.81 6.96v15.49c0 2.9-2.352 5.251-5.252 5.251H14.5a.9.9 0 0 1 0-1.8h8.057a3.452 3.452 0 0 0 3.452-3.451V6.96a.864.864 0 0 0-.864-.863h-14.06a.682.682 0 0 0-.683.682v17.663c0 .736-.174 1.348-.482 1.84a2.88 2.88 0 0 1-1.1 1.018 3.493 3.493 0 0 1-1.507.401h-.021l-.001-.9.001.9c-1.316 0-2.186-.599-2.69-1.349a3.6 3.6 0 0 1-.593-1.91v-6.644a2.7 2.7 0 0 1 2.7-2.699h.11a.9.9 0 1 1 0 1.8h-.11a.9.9 0 0 0-.9.9v6.643c0 .172.064.575.287.906.185.277.506.551 1.188.553l.034-.002a1.698 1.698 0 0 0 .655-.187c.165-.088.312-.21.42-.383.107-.17.209-.443.209-.887V6.78Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M13.1 12a.9.9 0 0 1 .9-.9h8a.9.9 0 1 1 0 1.8h-8a.9.9 0 0 1-.9-.9Zm.9 4.12a.9.9 0 0 0 0 1.8h4.5a.9.9 0 0 0 0-1.8H14Z"
        }
      )
    )
  )));
}, g = f;
export {
  g as default
};
